import { Table } from "@/app/entities/TableCredit";
import { apiFGTS } from "../http/httpClient";

export interface getPublicCreditResponse {
  tables: Table[];
}

export interface getPublicCreditParams {
  prazo?: number;
  birthDate: string;
  linkName: string;
  leadId?: string;
}

export async function publicCredit(cpf: string, params: getPublicCreditParams) {
  const { data } = await apiFGTS.patch<getPublicCreditResponse>(
    `/self-hire/${params.linkName}/simulate`,
    {
      type: "FGTS",
      cpf,
      birthDate: params.birthDate,
      prazo: params.prazo,
    },
  );

  return data;
}
